import React from 'react';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { format, parseISO, startOfWeek, endOfWeek, startOfMonth, endOfMonth, startOfQuarter, endOfQuarter, startOfYear, endOfYear, addWeeks, addMonths, addQuarters, addYears } from 'date-fns';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export const SESSION_DEBUT = '2000-01-01';
export const SESSION_FIN = '2099-12-31';

const PERIODES = [
  { key: 'session', label: 'Toute la session' },
  { key: 'semaine', label: 'Semaine' },
  { key: 'mois', label: 'Mois' },
  { key: 'trimestre', label: 'Trimestre' },
  { key: 'annee', label: 'Année' },
  { key: 'personnalise', label: 'Personnalisé' },
];

const SHIFT = { semaine: addWeeks, mois: addMonths, trimestre: addQuarters, annee: addYears };

const computeRange = (preset, ref) => {
  const now = ref || new Date();
  switch (preset) {
    case 'session': return [SESSION_DEBUT, SESSION_FIN];
    case 'semaine': return [format(startOfWeek(now, { weekStartsOn: 1 }), 'yyyy-MM-dd'), format(endOfWeek(now, { weekStartsOn: 1 }), 'yyyy-MM-dd')];
    case 'mois': return [format(startOfMonth(now), 'yyyy-MM-dd'), format(endOfMonth(now), 'yyyy-MM-dd')];
    case 'trimestre': return [format(startOfQuarter(now), 'yyyy-MM-dd'), format(endOfQuarter(now), 'yyyy-MM-dd')];
    case 'annee': return [format(startOfYear(now), 'yyyy-MM-dd'), format(endOfYear(now), 'yyyy-MM-dd')];
    default: return null;
  }
};

export function PeriodeFilter({ periode, setPeriode, debut, setDebut, fin, setFin, showSession = true }) {
  const presets = showSession ? PERIODES : PERIODES.filter(p => p.key !== 'session');

  const applyPeriode = (key, ref) => {
    setPeriode(key);
    const range = computeRange(key, ref);
    if (range) {
      setDebut(range[0]);
      setFin(range[1]);
    }
  };
  const shift = (dir) => {
    if (!SHIFT[periode] || !debut) return;
    applyPeriode(periode, SHIFT[periode](parseISO(debut), dir));
  };

  return (
    <div className="flex flex-wrap items-end gap-3">
      <div className="flex items-center gap-1.5 flex-wrap" data-testid="rapport-periode-filters">
        {presets.map(p => (
          <button
            key={p.key}
            type="button"
            onClick={() => applyPeriode(p.key)}
            data-testid={`periode-${p.key}`}
            className={`px-3 py-1.5 rounded-full text-xs font-medium transition-colors ${
              periode === p.key ? 'bg-indigo-600 text-white' : 'bg-slate-100 text-slate-600 hover:bg-slate-200'
            }`}
          >
            {p.label}
          </button>
        ))}
      </div>
      {periode !== 'session' && (
        <>
          {SHIFT[periode] && (
            <div className="flex items-center gap-0.5">
              <button type="button" onClick={() => shift(-1)} className="h-8 w-8 rounded-md border border-slate-200 bg-white hover:bg-slate-50 flex items-center justify-center" title="Période précédente" data-testid="periode-prev"><ChevronLeft className="w-4 h-4" /></button>
              <button type="button" onClick={() => shift(1)} className="h-8 w-8 rounded-md border border-slate-200 bg-white hover:bg-slate-50 flex items-center justify-center" title="Période suivante" data-testid="periode-next"><ChevronRight className="w-4 h-4" /></button>
            </div>
          )}
          <div className="space-y-1">
            <Label className="text-[10px] text-slate-500">Du</Label>
            <Input
              type="date" value={debut}
              onChange={(e) => { setDebut(e.target.value); setPeriode('personnalise'); }}
              className="w-36 h-8 text-xs" data-testid="date-debut-rapport"
            />
          </div>
          <div className="space-y-1">
            <Label className="text-[10px] text-slate-500">Au</Label>
            <Input
              type="date" value={fin}
              onChange={(e) => { setFin(e.target.value); setPeriode('personnalise'); }}
              className="w-36 h-8 text-xs" data-testid="date-fin-rapport"
            />
          </div>
        </>
      )}
    </div>
  );
}
